import type { IconData } from '@stacksjs/iconify-core'

export const il1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGMa12rbIW\"><path fill-opacity=\".7\" d=\"M0 0h512v512H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGMa12rbIW)\"><path fill=\"#fff\" d=\"M619.4 512H-112V0h731.4z\"/><path fill=\"#0038b8\" d=\"M619.4 115.2H-112V48h731.4zm0 350.5H-112v-67.2h731.4zm-483-275l110.1 191.6L359 191.6z\"/><path fill=\"#fff\" d=\"m225.8 317.8l20.9 35.5l21.4-35.3z\"/><path fill=\"#0038b8\" d=\"M136 320.6L246.2 129l112.4 190.8z\"/><path fill=\"#fff\" d=\"m225.8 191.6l20.9-35.5l21.4 35.4zM182 271.1l-21.7 36l41-.1l-19.3-36zm-21.3-66.5l41.2.3l-19.8 36.3zm151.2 67l20.9 35.5l-41.7-.5zm20.5-67l-41.2.3l19.8 36.3zm-114.3 0L189.7 256l28.8 50.3l52.8 1.2l32-51.5l-29.6-52z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default il1x1
